package devxertech.com.pages.career.careerAbout

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.backgroundSize
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CareerAboutSection(breakpoint: Breakpoint, sitePalette: SitePalette) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = if (breakpoint < Breakpoint.MD) 10.px else 50.px)
            .backgroundImage(url(Res.Image.dot_bg))
            .backgroundSize(BackgroundSize.Cover)
            .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
    ) {
        if (breakpoint <= Breakpoint.MD) {
            Column(
                modifier = Modifier.fillMaxWidth().margin(topBottom = 20.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    "Life at devxer technology",
                    modifier = Modifier
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(15.px)
                        .textTransform(TextTransform.Uppercase)
                        .margin(topBottom = if (breakpoint == Breakpoint.MD) 7.px else 10.px)
                )
                Row(
                    modifier = Modifier.width(if (breakpoint == Breakpoint.MD) 740.px else 100.percent)
                        .flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    SpanText(
                        "A workplace that ",
                        modifier = Modifier
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(24.px)
                            .fontWeight(FontWeight.Bold)
                            .textTransform(TextTransform.Uppercase)
                    )
                    SpanText(
                        "sparks joy",
                        modifier = Modifier
                            .color(sitePalette.primary.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(24.px)
                            .fontWeight(FontWeight.Bold)
                            .textTransform(TextTransform.Uppercase)
                    )
                    SpanText(
                        "At Devxer,we aim at building the best of everything. Be it technology, environment " +
                                "or relationships with our human resources. Our team is passionate about contributing " +
                                "to the world in a most productive manner and this is what enables us to deliver hundreds " +
                                "of successful projects every year. The chant of making it all possible is simple: “we care”. " +
                                "We believe that successful companies comprise of happy employees and this is why we invest " +
                                "a lot of our energies in providing the highest level of workplace satisfaction to our team " +
                                "members. ",
                        modifier = Modifier
                            .width(if (breakpoint == Breakpoint.MD) 650.px else if (window.screen.width < 375) 290.px else 350.px)
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(17.px)
                            .lineHeight(37.px)
                            .margin(left = 20.px, top = 10.px)
                    )
                }
            }
        }

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceEvenly
        ) {
            Image(
                src = Res.Image.career_about,
                description = "Devxer Technologies career information",
                modifier = Modifier.width(if (breakpoint > Breakpoint.LG) 595.px else if (breakpoint == Breakpoint.MD) 550.px else if (window.screen.width < 375) 290.px else 396.px)
                    .height(if (breakpoint > Breakpoint.LG) 386.px else if (breakpoint == Breakpoint.MD) 350.px else 268.px)
                    .margin(
                        top = if (breakpoint <= Breakpoint.MD) 20.px else 0.px,
                        left = if (breakpoint <= Breakpoint.MD) 20.px else 0.px
                    )
            )

            if (breakpoint > Breakpoint.MD) {
                Column(
                    modifier = Modifier.fillMaxWidth(51.percent).margin(topBottom = 40.px),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    SpanText(
                        "Life at devxer technology",
                        modifier = Modifier
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(if (breakpoint == Breakpoint.LG) 15.px else 18.px)
                            .textTransform(TextTransform.Uppercase)

                    )
                    Row(
                        modifier = Modifier,
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText(
                            "A workplace that",
                            modifier = Modifier
                                .color(sitePalette.commonSecondaryButtonColor.rgb)
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(if (breakpoint == Breakpoint.LG) 24.px else 30.px)
                                .fontWeight(FontWeight.Bold)
                                .textTransform(TextTransform.Uppercase)
                        )
                        SpanText(
                            " sparks joy",
                            modifier = Modifier
                                .color(sitePalette.primary.rgb)
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(if (breakpoint == Breakpoint.LG) 24.px else 30.px)
                                .fontWeight(FontWeight.Bold)
                                .textTransform(TextTransform.Uppercase)
                        )
                    }
                    SpanText(
                        "At Devxer, we aim at building the best of everything. Be it technology, environment " +
                                "or relationships with our human resources. Our team is passionate about contributing " +
                                "to the world in a most productive manner and this is what enables us to deliver hundreds " +
                                "of successful projects every year. The chant of making it all possible is simple: “we care”. " +
                                "We believe that successful companies comprise of happy employees and this is why we invest " +
                                "a lot of our energies in providing the highest level of workplace satisfaction to our team " +
                                "members.",
                        modifier = Modifier
                            .width(
                                if (window.screen.width > 1400) 800.px else 500.px
                            )
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(if (breakpoint == Breakpoint.LG) 14.px else 20.px)
                            .margin(left = 40.px, top = 5.px)
                            .lineHeight(1.5.em)
                            .textAlign(TextAlign.Justify)
                            .styleModifier {
                                property("max-width", "calc(100% - 40px)")
                                property("display", "-webkit-box")
                                property("-webkit-line-clamp", "7")
                                property("-webkit-box-orient", "vertical")
                                property("overflow", "hidden")
                            }
                    )
                }
            }
        }
    }
}
